// categoryProductMarkup.js
// Configuration for custom markup percentages for the first N products in specific categories
//
// Usage:
//   Map category names to objects containing:
//     - count: number of products to apply custom markup to (e.g., 8 for first 8 products)
//     - markup: markup percentage as decimal (e.g., 0.5 = 50%, 0.4 = 40%, 0.6 = 60%)
//   Products beyond the specified count will use the default markup from REACT_APP_PRODUCT_INCREMENT_PERCENT
//
// Example:
//   "Fresh Fruit": {
//     count: 8,      // First 8 products
//     markup: 0.5    // 50% markup for first 8 products
//   },
//   "Water": {
//     count: 6,      // First 6 products
//     markup: 0.3    // 30% markup for first 6 products
//   }

const categoryProductMarkup = {
    // Add your category-specific product markup configurations here
    // Format:
    // "Fresh Fruit": {
    //     count: 2,      // Number of products to apply custom markup
    //     markup: 0.25     // Markup percentage (0.4 = 40%, 0.5 = 50%, etc.)
    // }
};

export default categoryProductMarkup;

